import React, { useEffect } from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import { View } from './Base';
import AppBar from "@material-ui/core/AppBar/index";
import { Divider } from '@material-ui/core';
import HorizontalTabs, { navStyles } from './tab/hori';

import {useKeepAliveEffect} from '../keep';

import {setHeader,setFooter,changeNavigationStyle, setDrawerType, setHorizontalMenuPosition} from '../external/actions/Setting';
import { connect } from 'react-redux';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Button, { HelpLink } from './Button';
import { runtime, Util } from '../common';
import { COLLAPSED_DRAWER,FIXED_DRAWER } from '../external/constants/ActionTypes';
import App from '../external/containers/App';
import { auth } from 'codeArt/auth';
import { Html } from 'codeArt/components/Html';

function goBack(){
  App.current.back();
}

function ContainerHeaderImple(props) {

  // let oldDrawerType = props.drawerType;
  let isUnmounted = false;
  const mounted=()=>{
    let {setHeader,title,subtitle, back,sidebar,setDrawerType,header,setFooter,footer,drawerable,normal}=props;
    if(normal) return;//设置了正常属性，表示不参与全局环境设置
    setHeader({title,subtitle, back,drawerable,hidden:header&&header.hidden});  //为全局环境设置页面信息
    setFooter({hidden:footer&&footer.hidden});  //为全局环境设置页面信息
    if(sidebar && sidebar.hidden){
      setDrawerType(COLLAPSED_DRAWER);
    }else{
      setDrawerType(FIXED_DRAWER);
    }
    // if(sidebar){
    //   let {hidden} = sidebar;
    //   if(hidden) {
    //     // oldDrawerType = props.drawerType;
    //     setDrawerType(COLLAPSED_DRAWER);
    //   }
    // }
  }

  const unmounted=()=>{
    if(isUnmounted) return; //已经卸载，不重复卸载,这里主要解决两个页面切换时，可能由于重复卸载，倒是新页面加载成功后，老页面的卸载又执行了，导致BUG
    let {setHeader,setDrawerType,normal}=props;
    if(normal) return;//设置了正常属性，表示不参与全局环境设置
    isUnmounted = true;
    // setHeader({});
    // if(oldDrawerType){
    //   setDrawerType(oldDrawerType);
    // }
  }

  useEffect(() => {
    mounted();
    return () => {
      unmounted();
    };
  },[]); //追加 []参数，表示只在mount事件中执行，update不执行，避免死循环

  useKeepAliveEffect(() => {
    mounted();
    return () => {
      unmounted();
    };
  });

  const renderTools=()=>{
    let {tools,back}=props;
    return tools||back?<div className="d-flex flex-row align-items-center">
      {tools}
      </div>:null
    }

    let {title,solid, right,tools,hidden,className,description,titleClassName,descriptionClassName,face,flat,help,narrow,center}=props;
    tools = tools || right;
    let titleComponent = title && Util.type(title) !=="string" ? title:null;
    const renderDescription=()=>{
      return (
        description?(
          <div className="d-flex my-0">
            {Util.type(description)==="string"? <Html className={`m-text-dark-50 ${descriptionClassName}`} size="xs" code={description} />:description}
          </div>
        ):null
      );
    }

    // let extClassName = "";
    // if(solid || face){
    //   if(face) extClassName = "no-shadow c-l";
    // }
    // else extClassName="no-shadow c-bg-none c-px-0";

    const renderTitle=()=>{

      let obj = titleComponent?titleComponent:<h2 title={title} className={`mb-0 c-lh-0 font-weight-bold ${titleClassName}`}>{title}</h2>;

      if(help){
        return <div className="d-flex flex-row justify-content-start align-items-center">
                {obj}<HelpLink href={help} className="ml-2" size="md" />
               </div>;
      }
      return obj;
    }

    const classes = navStyles({});

    return (
      hidden?<div className="d-none">{renderTools()}</div>:
      <AppBar color="default" className={`d-flex flex-column justify-content-center ${classes.appBar} c-page-heading ${narrow?'c-page-heading-narrow align-items-center':''} ${face?'shadow-xs c-l':''} ${flat?'c-l0':''} ${className}`}>
         <div className="c-page-heading-title d-flex flex-row justify-content-between align-items-center">
           {renderTitle()}
           {renderTools()}
          </div>
      </AppBar>
    );
}

ContainerHeaderImple.defaultProps={
  className:'',
  titleClassName:'c-text-s2',
  descriptionClassName:'',
  solid:false,
  face:false,
  flat:false,
  back:false
}

const mapStateToProps = ({settings,router}) => {
  const {drawerType} = settings;
  return {drawerType,router}
};

const ContainerHeader = withRouter(connect(mapStateToProps, {
  setHeader,
  setFooter,
  setDrawerType
})(ContainerHeaderImple));


// export default _ContainerHeader;

export default class Index extends React.Component {

  constructor(props) {
    super(props);
    this.state={
    }
  }

  refresh({title,description}){
    this.setState({
      title,description
    });
  }

  render() {
    return (
      <ContainerHeader {...this.props} {...this.state} />
    )
  }
}



export class Header extends React.Component {

  constructor(props) {
    super(props);
  }

  renderTools(){
    let {tools,back}=this.props;
    return tools||back?<div className="d-flex flex-row align-items-center">
      {tools}
      {back?<Button className="ml-2" color="teal" onClick={()=>{goBack();}}>返回</Button>:null}
      </div>:null
    }

  render() {
    let { className,title,titleClassName,left,right } = this.props;
    let titleComponent = title && Util.type(title) !=="string" ? title:null;
    //支持left和right模式，如果用该模式，就不要用title和tools
    return (
      <div className={`d-flex flex-row justify-content-between align-items-center bg-white shadow-xs c-page-header c-l c-px-3 ${className}`}>
            {
             titleComponent?titleComponent:(title?<h2 title={title} className={`mb-0 c-text-s2 font-weight-bold ${titleClassName}`}>{title}</h2>:null)
           }
           {this.renderTools()}
           {left?<div className="d-flex flex-row justify-content-start align-items-center">{left}</div>:null}
           {right?<div className="d-flex flex-row justify-content-start align-items-center">{right}</div>:null}
      </div>
    );
  }

}

Header.defaultProps = {
  className:'',
  titleClassName:'',
  descriptionClassName:'',
  face:false
}

Header.TPageClassName="c-mt-10px c-ml-10px c-mr-10px"